import { SaisieInfosSouscripteur } from './../../models/form-state.model';

export interface InsuredState {
  insured?: SaisieInfosSouscripteur;
  isValid: boolean;
  duration: number;
}

export const initialState: InsuredState = {
  duration: -1,
  isValid: false
};
